var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPartitionedWindowStandard = function SvgPartitionedWindowStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#6cb8ef",
    d: "M20 2a18 18 0 100 36 18 18 0 100-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13v14h-4V13h4m2-2h-8v18h8V11zm8 2v4h-4v-4h4m2-2h-8v8h8v-8zm-2 12v4h-4v-4h4m2-2h-8v8h8v-8z",
    fill: "#6cb8ef"
  })));
};
export default SvgPartitionedWindowStandard;